export default function BeforeButton({ handlePrev, lockNextBtn }) {
	return (
		<button className="btn btn-primary" onClick={handlePrev} disabled={lockNextBtn}>
			<i className="fa-solid fa-chevron-left"></i> Anterior
		</button>
	);
}
